// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./global.css";
import { AuthProvider } from "./components/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Sentry — initialize before any React rendering so unhandled errors
// during component bootstrap are captured.
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV || "development",
  tracesSampleRate: 0.1,
  release: process.env.REACT_APP_GIT_COMMIT_SHA || "unknown",
  // Don't capture default PII; controllers attach context as needed.
  sendDefaultPii: false,
  integrations: [Sentry.browserTracingIntegration()],
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("No root element found");
}
const root = ReactDOM.createRoot(container);
root.render(
  <Sentry.ErrorBoundary fallback={<p>An error occurred. Please refresh.</p>} showDialog={false}>
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  </Sentry.ErrorBoundary>
);
